import React from 'react';

import classes from '../installPics.css';

import FirstInstallImgPic from '../../../../../../../assets/FirstInstallImg.JPG';

const FirstInstallImg = () => (
    <div className={classes.installImages}>
        <img alt="22kW residential installation in New Jersey" src={FirstInstallImgPic} className={classes.installImg} />
    </div>
);


export default FirstInstallImg;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/PitchedRoofImages/FirstInstallImg.js